const deliveryMethodEnum = {
  email: 19000,
  posta: 19001,
};

const yesNoEnum = [
  {label: 'Da', value: true},
  {label: 'Nu', value: false},
];

export {deliveryMethodEnum, yesNoEnum};
